module.exports = __webpack_public_path__ + "img/a.e640ab3a.jpg";